import axios from "axios";
import utils from "../utils";

const localStorageKey = {
  TOKEN: 'token',
  USER_DATA: 'user_data'
}

const setTokenToLocalStorage = (token) => {
  localStorage.setItem(localStorageKey.TOKEN, token);
}

const getTokenFromLocalStorage = () => {
  return localStorage.getItem(localStorageKey.TOKEN)
}

const setUserDataToLocalStorage = (userData) => {
  localStorage.setItem(localStorageKey.USER_DATA, JSON.stringify(userData));
}

const getUserDataFromLocalStorage = () => {
  const items = JSON.parse(localStorage.getItem(localStorageKey.USER_DATA));
  return items
}

const logOut = () => {
  localStorage.removeItem(localStorageKey.TOKEN)
  localStorage.removeItem(localStorageKey.USER_DATA)
}

const isLoggedIn = () => {
  const token = getTokenFromLocalStorage();
  return token ? true : false;
}

/**
 * Login Service
 * For user login, passing email and password
 * loginData = {email, password}
 */
const login = async (loginData) => {
  try {
    const response = await axios.post(`${utils.baseUrl}/auth/login`, loginData);

    return {
      message: response.data.message,
      data: response.data.data,
      status: response.status
    }
  } catch (error) {
    return {
      message: error.response.data.message,
      status: error.response.status
    }
  }
}

const authService = {
  login,
  localStorageKey,
  setTokenToLocalStorage,
  getTokenFromLocalStorage,
  setUserDataToLocalStorage,
  getUserDataFromLocalStorage,
  isLoggedIn,
  logOut
}

export default authService